import { defineMessages } from 'react-intl'

const messages = defineMessages({
  confirmBooking: {
    id: 'global.confirm-booking',
  },
})

export default messages
